var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-form', {
    ref: "form",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "model": _vm.formData,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "minimumVersion",
      "label": "Minimum version"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    model: {
      value: _vm.formData.minimumVersion,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "minimumVersion", $$v);
      },
      expression: "formData.minimumVersion"
    }
  })], 1), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("Update")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }